import { useEffect } from "react";

// On phones (under 768px) every table in the admin panel turns into a stack of cards:
// the header row is hidden and each cell shows its column name next to its value.
// Desktop is untouched. The column names are copied from each table's header automatically.
const CSS = `
@media (max-width: 767px) {
  table.rt { display: block; width: 100%; }
  table.rt thead { display: none; }
  table.rt tbody { display: block; }
  table.rt tr {
    display: block;
    margin: 0 0 12px 0;
    padding: 6px 2px;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
  }
  table.rt td {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 8px 14px !important;
    border: 0 !important;
    text-align: right !important;
    white-space: normal !important;
    word-break: break-word;
  }
  table.rt td::before {
    content: attr(data-label);
    flex-shrink: 0;
    max-width: 40%;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #64748b;
    text-align: left;
  }
  table.rt td[data-label=""]::before { display: none; }
  table.rt td[colspan] { display: block; text-align: center !important; }
  table.rt td[colspan]::before { display: none; }
  /* groups of buttons (View / Edit / Reset ...) wrap instead of running off-screen */
  table.rt td > div.flex { flex-wrap: wrap; justify-content: flex-end; }
  table.rt td .justify-center { justify-content: flex-end; }
}
`;

const label = () => {
  document.querySelectorAll("table").forEach((table) => {
    table.classList.add("rt");
    const heads = Array.from(table.querySelectorAll("thead th")).map((th) => th.textContent.trim());
    table.querySelectorAll("tbody tr").forEach((tr) => {
      Array.from(tr.children).forEach((td, i) => {
        if (td.tagName !== "TD" || td.colSpan > 1) return;
        const text = heads[i] || "";
        if (td.getAttribute("data-label") !== text) td.setAttribute("data-label", text);
      });
    });
  });
};

export default function ResponsiveTables() {
  useEffect(() => {
    let queued = false;
    const run = () => {
      if (queued) return;
      queued = true;
      setTimeout(() => {
        queued = false;
        label();
      }, 0);
    };
    run();
    const observer = new MutationObserver(run);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  return <style>{CSS}</style>;
}
